<div class="min-vh-100">
  <div class="d-flex flex-column gap-4 gap-lg-3 mx-auto">
    <section class="entity-config-top rounded-top-4 overflow-hidden border-0">
      <div class="entity-config-top-hero p-2">
        <div class="row g-2 align-items-start flex-nowrap">
          <div class="col">
            <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">{{ hero.title }}</h1>
            <p class="entity-page-subtitle text-white mb-0">
              {{ hero.description }}
            </p>
          </div>

          <div class="col-auto d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-primary-dark text-xs shadow-lg d-inline-flex align-items-center"
              data-bs-toggle="modal"
              data-bs-target="#create_workflow"
              @click="open_create_workflow_modal"
            >
              <i class="bi bi-plus-circle-fill me-2"></i>
              <span>Create New Workflow</span>
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="entity-inventory-panel rounded-4 border shadow-sm p-2">
      <div class="row g-2 align-items-start align-items-lg-center mb-3">
        <div class="col-12 col-lg">
          <div class="d-flex align-items-center gap-3">
            <div class="entity-section-icon rounded-3 d-inline-flex align-items-center justify-content-center">
              <i class="bi bi-diagram-3-fill"></i>
            </div>
            <div class="entity-section-title fw-bold fs-6">
              {{ route_entity_type_id ? 'Entity Workflows' : 'All Workflows' }}
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-auto">
          <div class="d-grid d-sm-flex align-items-stretch gap-2">
            <div class="d-inline-flex align-items-center gap-2">
              <i class="bi bi-funnel-fill"></i>
              <select
                v-model="workflow_status_filter"
                class="form-select form-select-sm rounded-small"
                aria-label="Filter workflows"
              >
                <option value="all">All</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>

            <div class="d-inline-flex align-items-center gap-2">
              <i class="bi bi-sort-down"></i>
              <select
                v-model="workflow_sort_order"
                class="form-select form-select-sm rounded-small"
                aria-label="Sort workflows"
              >
                <option value="updated_desc">Newest Updated</option>
                <option value="updated_asc">Oldest Updated</option>
                <option value="name_asc">Name A-Z</option>
                <option value="name_desc">Name Z-A</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="entity-table-head secondary-color d-none d-lg-block rounded-3 mb-2 px-3 py-2 text-uppercase tracking-wide">
        <div class="row g-2 align-items-center">
          <div class="col-lg-4">Workflow Name</div>
          <div class="col-lg-2">Status</div>
          <div class="col-lg-4">Assigned Forms</div>
          <div class="col-lg-2"></div>
        </div>
      </div>

      <div v-if="workflows_loading" class="d-flex align-items-center gap-2 text-secondary text-xs py-2">
        <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
        <span>Loading workflows...</span>
      </div>

      <div v-else-if="filtered_workflows.length" class="d-flex flex-column gap-2">
        <article
          v-for="workflow in paginated_workflows"
          :key="workflow.id"
          class="entity-row-card workflow-row-card bg-white rounded-4 border shadow-sm"
        >
          <div class="entity-row-layout row g-2 align-items-center">
            <div class="entity-name-block workflow-row-identity col-10 col-lg-4 d-flex align-items-start align-items-sm-center gap-3">
              <div class="entity-type-icon entity-icon-surface rounded-3 d-inline-flex align-items-center justify-content-center">
                <i :class="workflow.icon"></i>
              </div>
              <div>
                <div class="entity-name workflow-row-title fw-bold">{{ workflow.title }}</div>
                <div class="entity-updated workflow-row-description text-secondary">{{ workflow.description }}</div>
                <div class="workflow-row-meta">{{ workflow.statusMeta }}</div>
              </div>
            </div>

            <div class="col-2 d-flex justify-content-end align-items-start d-lg-none">
              <button
                type="button"
                class="entity-row-arrow rounded-circle d-inline-flex align-items-center justify-content-center"
                @click="go_to_configure_workflow(workflow)"
              >
                <i class="bi bi-chevron-right"></i>
              </button>
            </div>

            <div class="entity-status-block col-4 col-lg-2">
              <span class="entity-status-pill d-inline-flex align-items-center justify-content-center fw-bold text-uppercase" :class="workflow.statusClass">
                {{ workflow.status }}
              </span>
            </div>

            <div class="entity-binding-block workflow-row-forms col-8 col-lg-4 d-flex flex-wrap align-items-center gap-1">
              <span class="fw-semibold" :class="workflow.assignedForms.length ? 'text-dark' : 'workflow-assigned-empty fst-italic'">
                {{ workflow.assignedForms.length ? `${workflow.assignedForms.length} form${workflow.assignedForms.length === 1 ? '' : 's'} assigned` : 'No forms linked' }}
              </span>
            </div>

            <div class="col-12 col-lg-2 d-flex justify-content-end align-items-center gap-2">
              <button
                type="button"
                class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1"
                data-bs-toggle="modal"
                data-bs-target="#edit_workflow"
                @click="open_edit_workflow_modal(workflow)"
              >
                Edit
              </button>
              <button
                type="button"
                class="entity-row-arrow rounded-circle d-inline-flex align-items-center justify-content-center"
                aria-label="Configure workflow logic"
                @click="go_to_configure_workflow(workflow)"
              >
                <i class="bi bi-chevron-right fs-6"></i>
              </button>
            </div>
          </div>
        </article>

        <div
          v-if="paginated_workflows.length"
          class="d-flex flex-column gap-3 mt-3"
        >
          <div class="d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-between gap-3">
            <div class="text-secondary small">
              Showing {{ pagination_start_item }} to {{ pagination_end_item }} of {{ filtered_workflows.length }} entries
            </div>
            <div v-if="workflow_total_pages > 1" class="d-flex align-items-center gap-2 flex-wrap">
              <button
                type="button"
                class="btn entity-panel-btn btn-sm rounded-small px-3 py-2"
                :disabled="workflow_current_page <= 1"
                @click="go_to_workflow_page(workflow_current_page - 1)"
              >
                Previous
              </button>
              <button
                v-for="page in workflow_visible_page_numbers"
                :key="`workflow-page-${page}`"
                type="button"
                class="btn btn-sm rounded-small px-3 py-2"
                :class="page === workflow_current_page ? 'btn-primary' : 'entity-panel-btn'"
                @click="go_to_workflow_page(page)"
              >
                {{ page }}
              </button>
              <button
                type="button"
                class="btn entity-panel-btn btn-sm rounded-small px-3 py-2"
                :disabled="workflow_current_page >= workflow_total_pages"
                @click="go_to_workflow_page(workflow_current_page + 1)"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="card border-0 shadow-sm rounded-4">
        <div class="card-body p-4 p-lg-5 d-flex flex-column align-items-center justify-content-center text-center gap-3">
          <div class="entity-icon-surface rounded-4 d-inline-flex align-items-center justify-content-center p-4">
            <i class="bi bi-inbox fs-1 opacity-75"></i>
          </div>
          <div>
            <p class="fw-bold text-x mb-1">No Workflows Found</p>
            <p class="text-secondary text-xs mb-0">
              {{ route_entity_type_id ? 'No workflows are linked to this entity type yet.' : 'Create your first workflow to get started.' }}
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>

  <teleport to="body">
    <div class="modal fade" id="create_workflow" tabindex="-1" aria-labelledby="create_workflow_label" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <p class="modal-title text-white text-xs mb-0" id="create_workflow_label">Create Workflow</p>
            <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div class="modal-form-group form-group mb-3">
              <label for="workflow_name" class="modal-form-label form-label text-xs">Workflow Name:</label>
              <input
                id="workflow_name"
                v-model="create_workflow_form.name"
                type="text"
                class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
                placeholder="Please enter a workflow name"
              />
            </div>

            <div class="modal-form-group form-group mb-3">
              <label for="workflow_description" class="modal-form-label form-label text-xs">Workflow Description:</label>
              <textarea
                id="workflow_description"
                v-model="create_workflow_form.description"
                rows="4"
                class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
                placeholder="Please enter a workflow description"
              ></textarea>
            </div>

            <small v-if="modal_error_message" class="text-danger p-2 text-xs fw-bold d-block">
              {{ modal_error_message }}
            </small>
          </div>

          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button
              type="button"
               class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1"
              @click="create_workflow"
              :disabled="create_workflow_running"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="edit_workflow" tabindex="-1" aria-labelledby="edit_workflow_label" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content bg-white rounded-4 p-0 shadow-lg">
          <div class="modal-header border-bottom-0 cute-header shadow-lg">
            <p class="modal-title text-white text-xs mb-0" id="edit_workflow_label">Edit Workflow</p>
            <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div class="modal-form-group form-group mb-3">
              <label for="edit_workflow_name" class="modal-form-label form-label text-xs">Workflow Name:</label>
              <input
                id="edit_workflow_name"
                v-model="edit_workflow_form.name"
                type="text"
                class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
                placeholder="Please enter a workflow name"
              />
            </div>

            <div class="modal-form-group form-group mb-3">
              <label for="edit_workflow_description" class="modal-form-label form-label text-xs">Workflow Description:</label>
              <textarea
                id="edit_workflow_description"
                v-model="edit_workflow_form.description"
                rows="4"
                class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
                placeholder="Please enter a workflow description"
              ></textarea>
            </div>

            <small v-if="edit_modal_error_message" class="text-danger p-2 text-xs fw-bold d-block">
              {{ edit_modal_error_message }}
            </small>
          </div>

          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button
              type="button"
              class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1"
              @click="update_workflow"
              :disabled="edit_workflow_running"
            >
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</div>
